// En este fichero defeniremos los IDs de las acciones de nuestros plugins.
export const FACEBOOK_PLUGIN_ID = "15550f37-7d19-40fd-98cb-f59353f6687e";
export const FACEBOOK_ACTION_GET_FORMS = "8456cdd8-e43d-4a0e-be1c-95b86501a8d9";
export const FACEBOOK_ACTION_GET_PAGES = "17947b76-3a35-483b-b413-31732da9ec34";
export const FACEBOOK_ACTION_GET_FIELDS = "e373467e-2ba6-40d3-808e-892d68a28ad6";
export const FACEBOOK_ACTION_GET_LEAD = "49e8c3a5-75af-4a58-a706-f9bc47561c34";
export const BREVO_ACTION_WEBHOOK_GET_STATS = "22d0da6e-dd67-4f00-b3e2-493234403d7e";